import { AitCellData } from "./AitCellData";
import { AitRowData } from "./AitRowData";
import { AitHeaderRowData } from "./interface";

/**
 * Strip repeat-related metadata from body rows and normalise cell shapes.
 *
 * This function returns shallow copies of rows and cells with only the
 * canonical properties retained (it removes any transient repeat-related
 * fields). It is useful when preparing rows for serialisation or comparison.
 *
 * @template T - The cell payload type
 * @param rows - Array of body rows to normalise
 * @returns A new array of `AitRowData<T>` with repeat metadata removed
 */
export const removeRowRepeatInfo = <T>(rows: AitRowData<T>[]): AitRowData<T>[] => {
  return rows.map((r) => {
    const ret: AitRowData<T> = {
      aitid: r.aitid,
      cells: r.cells
        // .filter(c => !c.replacedText?.includes("__filler"))
        .map((c) => {
          return {
            aitid: c.aitid,
            text: c.text,
            justifyText: c.justifyText,
            comments: c.comments,
            // colSpan: c.colSpan,
            // rowSpan: c.rowSpan,
            colWidth: c.colWidth,
            textIndents: c.textIndents,
            coreTrafficLight: c.coreTrafficLight,
            templateAitId: c.templateAitId,
            templateColumnAitId: c.templateColumnAitId,
            columnId: c.columnId,
            // replacedText: undefined,
            // repeatColSpan: undefined,
            // repeatRowSpan: undefined,
          } as AitCellData<T>;
        }),
      // spaceAfter: false,
      // rowRepeat: undefined,
      coreTrafficLight: r.coreTrafficLight,
      templateAitId: r.templateAitId,
      annotation: r.annotation,
    };
    return ret;
  });
};

/**
 * Strip repeat-related metadata from header rows and return simplified copies.
 *
 * Behaviour mirrors `removeRowRepeatInfo` but retains `colSpan`/`rowSpan`
 * values which are important for header rendering.
 *
 * @template T - The header cell payload type
 * @param rows - Array of header rows to normalise
 * @returns A new array of `AitHeaderRowData<T>` with repeat metadata removed
 */
export const removeHeaderRowRepeatInfo = <T>(
  rows: AitHeaderRowData<T>[],
): AitHeaderRowData<T>[] => {
  return rows.map((r) => {
    const ret: AitHeaderRowData<T> = {
      aitid: r.aitid,
      cells: r.cells
        // .filter(c => !c.replacedText?.includes("__filler"))
        .map((c) => {
          return {
            aitid: c.aitid,
            text: c.text,
            justifyText: c.justifyText,
            comments: c.comments,
            colSpan: c.colSpan,
            rowSpan: c.rowSpan,
            colWidth: c.colWidth,
            textIndents: c.textIndents,
            coreTrafficLight: c.coreTrafficLight,
            templateAitId: c.templateAitId,
            templateColumnAitId: c.templateColumnAitId,
            columnId: c.columnId,
            // replacedText: undefined,
            // repeatColSpan: undefined,
            // repeatRowSpan: undefined,
          };
        }),
      // spaceAfter: false,
      // rowRepeat: undefined,
      coreTrafficLight: r.coreTrafficLight,
      templateAitId: r.templateAitId,
      annotation: r.annotation,
    };
    return ret;
  });
};
